import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=11154613&scoped=true"
import script from "./Memo.vue?vue&type=script&lang=js"
export * from "./Memo.vue?vue&type=script&lang=js"
import style0 from "./Memo.vue?vue&type=style&index=0&id=11154613&prod&scoped=true&lang=css"
import style1 from "./Memo.vue?vue&type=style&index=1&id=11154613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11154613",
  null
  
)

export default component.exports